import type { UserRole } from '../types';

export interface RolePermissions {
  canAccessDashboard: boolean;
  canAccessMeetings: boolean;
  canAccessIntegrations: boolean;
  canAccessSettings: boolean;

  canAccessPersonalSettings: boolean;
  canAccessGeneralSettings: boolean;
  canAccessBillingSettings: boolean;
  canAccessUserManagement: boolean;
  canAccessSecuritySettings: boolean;

  canConfigureIntegrations: boolean;
  canManageUsers: boolean;
}

export const rolePermissions: Record<UserRole, RolePermissions> = {
  admin: {
    canAccessDashboard: true,
    canAccessMeetings: true,
    canAccessIntegrations: true,
    canAccessSettings: true,
    canAccessPersonalSettings: true,
    canAccessGeneralSettings: true,
    canAccessBillingSettings: true,
    canAccessUserManagement: true,
    canAccessSecuritySettings: true,
    canConfigureIntegrations: true,
    canManageUsers: true,
  },

  member: {
    canAccessDashboard: true,
    canAccessMeetings: true,
    canAccessIntegrations: true,
    canAccessSettings: true,
    canAccessPersonalSettings: true,
    canAccessGeneralSettings: false,
    canAccessBillingSettings: false,
    canAccessUserManagement: false,
    // Security is PERSONAL (own 2FA, password, sessions, MCP switch) - it was wrongly
    // admin-gated, locking members out of 2FA and the MCP opt-in (fixed 2026-08-25).
    canAccessSecuritySettings: true,
    canConfigureIntegrations: true,
    canManageUsers: false,
  },
};

export function hasPermission(
  role: UserRole | undefined,
  permission: keyof RolePermissions,
): boolean {
  if (!role) return false;
  return rolePermissions[role]?.[permission] ?? false;
}

export function getRoleDisplayName(role: UserRole): string {
  switch (role) {
    case 'admin':
      return 'Admin';
    case 'member':
      return 'Member';
    default:
      return 'Unknown';
  }
}

export function getRoleDescription(role: UserRole): string {
  switch (role) {
    case 'admin':
      return 'Full access to workspace settings, billing, integrations, and user management';
    case 'member':
      return 'Full account access to meetings, action items, and personal settings';
    default:
      return '';
  }
}
